export const SET_GEOLOCATION: string = 'SET_GEOLOCATION';
export const SET_GEOLOCATION_ERROR: string = 'SET_GEOLOCATION_ERROR';
